import { onError } from '@apollo/client/link/error';

const link = onError(({ graphQLErrors, networkError, operation }) => {
  // biome-ignore lint/style/useBlockStatements: legacy code - style/useBlockStatements
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) => {
      console.error(
        `[Graphql error]: Message: ${message}, Location: ${
          locations ? JSON.stringify(locations) : locations
        }, Path: ${path}`,
      );
    });

  if (operation.operationName === 'createSocketSession') {
    console.log(
      '%c Hey! looks like you have the socket feature activated and because you have not running the server the mutation is going to fail 😥. If you want to disable it just set socketDisable to true in the localStorage.',
      'color: #09f; background: rgba(0,0,0,0.02); padding: 12px 0',
    );
  }

  if (networkError) {
    console.error(`[Network Error]: ${networkError}`);
  }
});

export default link;
